import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loader-msg',
  templateUrl: './loader-msg.component.html',
  styleUrls: ['./loader-msg.component.css']
})
export class LoaderMsgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
